/// <reference types="webpack-env" />

import 'core-js';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import { store } from './store';
import { getLDProvider } from './contexts/LaunchDarklyProvider';

async function enableMocking() {
  // Only enable mocks in development unless explicitly disabled
  if (process.env.NODE_ENV !== 'development' || process.env.REACT_APP_DISABLE_MOCKS === 'true') {
    return;
  }

  const { worker } = await import('./mocks/browser');

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start();
}

// console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV === 'development') {
  // for api url submission
  window._CMS_ = {
    APIM: {
      baseUrl: 'https://dev.api-au.qbe.com/digital-address-api/v1',
    },
    API: {
      baseurl: 'https://sit.api-ext.qbe.com.au',
    },
    ENV: 'local',
    MAX_FILE_UPLOAD_SIZE_IN_MB: 10,
    ENABLE_FILE_UPLOAD: true,
    ALLOWED_FILE_EXTENSIONS: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'png', 'jpeg', 'jpg', 'eml', 'zip', 'rar', '7z'],
    ldClientId: '68788d27abd0fd09233eac3c',
    recaptchaKey: '6LdnYnobAAAAAP194y4KCE3F5p01dlQU2ptC7nmy',
  };
}

enableMocking().then(() => {
  // TODO: migrate over to `createRoot` when mui v4 is removed?

  const container = document.getElementById('root') as HTMLElement;
  const root = createRoot(container);

  (async () => {
    try {
      const LDProvider = await getLDProvider();

      if (!LDProvider) {
        console.error('LaunchDarkly provider failed to initialize');
        root.render(
          <React.StrictMode>
            <Provider store={store}>
              <App />
            </Provider>
          </React.StrictMode>
        );
        return;
      }

      root.render(
        <React.StrictMode>
          <Provider store={store}>
            <LDProvider>
              <App />
            </LDProvider>
          </Provider>
        </React.StrictMode>
      );
    } catch (error) {
      console.error('Failed to initialize LaunchDarkly provider:', error);
      root.render(
        <React.StrictMode>
          <Provider store={store}>
            <App />
          </Provider>
        </React.StrictMode>
      );
    }
  })();
});

// Hot Module Replacement
const hotModule = module;
if (hotModule.hot && process.env.NODE_ENV === 'development') {
  hotModule.hot.accept();
}
